const calculateTotalGrowth = (data, uniqueRowTitles, upperScale, lowerScale) => {
  if (!Array.isArray(data) || data.length < 2) return 0;

  // Detect the scale used by the recorded values (fallback to provided bounds)
  const observed = [];
  for (const item of data) {
    for (const key of uniqueRowTitles) {
      const v = item[key]?.value;
      if (typeof v === 'number') observed.push(v);
    }
  }
  const obsMin = observed.length ? Math.min(...observed) : lowerScale ?? 0;
  const obsMax = observed.length ? Math.max(...observed) : upperScale ?? 5;

  // Use the value-scale, not ReachStart/End if they disagree
  const lo = (typeof lowerScale === 'number' && lowerScale <= obsMin) ? lowerScale : Math.floor(obsMin);
  const hi = (typeof upperScale === 'number' && upperScale >= obsMax) ? upperScale : Math.ceil(obsMax);
  const range = hi - lo;
  if (range <= 0) return 0;

  const first = data[0];
  const last = data[data.length - 1];

  let deltaSum = 0;
  let used = 0;

  for (const key of uniqueRowTitles) {
    const v1 = first[key]?.value;
    const v2 = last[key]?.value;
    if (typeof v1 !== 'number' || typeof v2 !== 'number') continue;

    deltaSum += (v2 - v1);
    used += 1;
  }

  if (!used) return 0;

  return (deltaSum / (used * range)) * 100;
};

export default calculateTotalGrowth;
